import { Setting } from "./Setting";

export const INITIAL_VALUES: Setting = {
	SettingId: null,
	SettingName: "",
	Value: "",
	Description: "",
};
